/**
 * Displays a person as "<last name>, <first name>", the convention used in
 * Vietnam and applied throughout the UI regardless of the selected language so
 * lists stay comparable between locales.
 *
 * A missing part drops the comma with it — "Nguyen," or ", Mai" would read as a
 * bug rather than as an incomplete record.
 */
export const formatUserName = (firstName?: string | null, lastName?: string | null): string => {
  const first = firstName?.trim() ?? "";
  const last = lastName?.trim() ?? "";

  if (first && last) {
    return `${last}, ${first}`;
  }
  return last || first;
};

/** Sorts by last name, matching how the names are displayed. */
export const compareByUserName = (
  a: {firstName?: string | null; lastName?: string | null},
  b: {firstName?: string | null; lastName?: string | null},
): number => formatUserName(a.firstName, a.lastName)
  .localeCompare(formatUserName(b.firstName, b.lastName));
